<template>
  <div v-if="visible" class="metadata">
    <ncs-empty-result v-if="result.pagination.rows === 0"/>
    <template v-else>
      <ncs-page-selector/>
      <ncs-fixed-column-table :center="false" :allowFixed="false">
        <table class="documents-table table table-borderless table-striped table-hover table-sm">
          <thead>
          <tr class="text-center text-nowrap">
            <th class="align-top">{{t('result.context.header.document.level')}}</th>
            <th class="align-top">{{t('result.context.header.document.gender')}}</th>
            <th class="align-top">{{t('result.context.header.document.l1')}}</th>
            <th class="align-top">{{t('result.context.header.document.english_status')}}</th>
            <th class="align-top">{{t('result.context.header.document.preparation_course')}}</th>
            <th class="align-top">{{t('result.context.header.document.text_formality')}}</th>
            <th class="align-top">{{t('result.context.header.document.text_type')}}</th>
            <th class="align-top">{{t('result.context.header.document.illocutionary_act')}}</th>
            <th class="align-top">{{t('result.context.header.document.text_topic')}}</th>
            <th class="align-top">
              {{t('result.context.header.document.candidate_number')}}
              <br/>
              <i>({{fn(result.total_candidates)}} {{t('result.documents.candidate_number.distinct')}})</i>
            </th>
            <th class="align-top">{{t('result.context.header.document.unit_count')}} <br/> <i>{{fn(result.total_units)}}</i></th>
          </tr>
          </thead>
          <tbody ref="tableBody">
          <tr v-for="document in result.documents">
            <td class="text-nowrap">{{document.level}}</td>
            <td class="text-nowrap">{{document.gender}}</td>
            <td class="text-nowrap">{{document.l1}}</td>
            <td class="text-nowrap">{{document.english_status}}</td>
            <td class="text-nowrap">{{document.preparation_course}}</td>
            <td class="text-nowrap">{{document.text_formality}}</td>
            <td class="text-nowrap">{{document.text_type}}</td>
            <td class="text-nowrap">{{document.illocutionary_act}}</td>
            <td class="text-nowrap">{{document.text_topic}}</td>
            <td class="text-nowrap">{{document.candidate_number}}</td>
            <td class="text-nowrap">{{fn(document.unit_count)}}</td>
          </tr>
          </tbody>
        </table>
      </ncs-fixed-column-table>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue"
import { useApiStore, useNcsI18n } from "ncs"

const { t, fn } = useNcsI18n()
const apiStore = useApiStore()

const result = computed(() => apiStore.response)
const visible = computed(() => apiStore.query?.type === 'documents')
</script>
